import { DateFilterOptionsDto, SearchAchReturnRequestDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';
import { AchCompany } from './company.entity';
import { defaultAchReturnFilterDto } from './data/ach.data';

export class AchReturnFilter extends DomainEntity<SearchAchReturnRequestDto> {
    constructor(protected dto = defaultAchReturnFilterDto) {
        super(dto);
    }

    private _achCompanyList: AchCompany[] = [];

    public createDefault(): this {
        return new AchReturnFilter() as this;
    }

    public get effectiveDateFilterOption() {
        return this.dto.effectiveDateFilterOption ?? ({} as unknown as DateFilterOptionsDto);
    }

    public set effectiveDateFilterOption(effectiveDateFilterOption: DateFilterOptionsDto) {
        this.dto.effectiveDateFilterOption = effectiveDateFilterOption;
    }

    public get effectiveDateStart() {
        return this.dto.effectiveDateStart;
    }

    public set effectiveDateStart(effectiveDateStart) {
        this.dto.effectiveDateStart = effectiveDateStart;
    }

    public get effectiveDateEnd() {
        return this.dto.effectiveDateEnd;
    }

    public set effectiveDateEnd(effectiveDateEnd) {
        this.dto.effectiveDateEnd = effectiveDateEnd;
    }

    public get receivedDateFilterOption() {
        return this.dto.receivedDateFilterOption ?? ({} as unknown as DateFilterOptionsDto);
    }

    public set receivedDateFilterOption(receivedDateFilterOption: DateFilterOptionsDto) {
        this.dto.receivedDateFilterOption = receivedDateFilterOption;
    }

    public get receivedDateStart() {
        return this.dto.receivedDateStart;
    }

    public set receivedDateStart(receivedDateStart) {
        this.dto.receivedDateStart = receivedDateStart;
    }

    public get receivedDateEnd() {
        return this.dto.receivedDateEnd;
    }

    public set receivedDateEnd(receivedDateEnd) {
        this.dto.receivedDateEnd = receivedDateEnd;
    }

    public get achCompanies() {
        return this._achCompanyList;
    }

    public set achCompanies(achCompanies) {
        this._achCompanyList = achCompanies;
        this.dto.achCompanies = this._achCompanyList
            .map(company => company.companyGuidUniqueId)
            .filter((id): id is string => typeof id === 'string');
    }

    public get recipientName() {
        return this.dto.recipientName || '';
    }

    public set recipientName(recipientName) {
        this.dto.recipientName = recipientName;
    }
}
